import React from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles';

const PF2MIconButton = React.forwardRef(({
  icon,
  size,
  onClick,
  disabled,
  variant,
  classes,
  buttonStyles,
  ...props
}, ref) => {
  const variantClassMap = {
    filled: classes.filled,
    outlined: classes.outlined,
  };

  const variantClasses = variantClassMap[variant] || classes.outlined;

  const className = classNames(classes.base, variantClasses);
  return (
    <IconButton
      ref={ref}
      {...props}
      size={size}
      disabled={disabled}
      onClick={onClick}
      className={className}
      style={{ ...buttonStyles }}
    >
      {icon ?? null}
    </IconButton>
  );
});

PF2MIconButton.PropTypes = {
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['filled', 'outlined']),
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  classes: PropTypes.object.isRequired,
  buttonStyles: PropTypes.object,
};

PF2MIconButton.defaultProps = {
  onClick: () => {},
  disabled: false,
  size: 'small',
  variant: 'outlined',
  buttonStyles: {},
};

export default withStyles(styles)(PF2MIconButton);
